import { ChangeEvent, Fragment, useState } from 'react';

import { toast } from 'react-toastify';
import clsx from 'clsx';

import {
  checkFeeInfo,
  getAmountCommissionSStorage,
  numberFormat,
  setAmountCommissionsSStorage,
  setAmountSStorage,
} from '@utils';
import { Button, InfoPayment } from '@ui';

import { IAmountButtonProps } from './types';
import { useCalculateCommissionAmountQuery } from './api';

export const AmountButton = ({
  value,
  type,
  showInfoPayment,
  enterAmountData,
  disabled = false,
  onClientAmount,
  onCommissionCalculated,
  salom = false,
}: IAmountButtonProps) => {
  const { mutate, isPending } = useCalculateCommissionAmountQuery();
  const [hasError, setHasError] = useState(false);
  const calculatedCommissions = getAmountCommissionSStorage();

  const infoPay = Array.isArray(calculatedCommissions)
    ? calculatedCommissions?.find(
      (transactionType: any) => transactionType.groupName === type
    )
    : null;

  const max: string = checkFeeInfo('max', String(infoPay?.feeInfo?.max ?? 0));

  const min: string = checkFeeInfo(
    'min',
    String(infoPay?.feeInfo?.min ?? 0),
    `${max ? ',' : ''}`
  );
  const infoStatic: string = checkFeeInfo(
    ' +',
    String(infoPay?.feeInfo.static ?? 0),
    ','
  );

  const handleCalculateCommission = () => {
    if (value === '') {
      toast.error('Введите сумму!');
      setHasError(true);
      return;
    }
    setHasError(false);
    mutate(
      {
        amount: value,
        sessionToken: enterAmountData?.payload?.sessionToken ?? '',
      },
      {
        onSuccess(data) {
          setAmountSStorage(value);
          setAmountCommissionsSStorage(data);
          onCommissionCalculated?.(false);
        },
      }
    );
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (!/^\d*([.,]\d{0,2})?$/.test(value) && value !== '') return;

    setHasError(false);
    onClientAmount({
      ...event,
      target: {
        ...event.target,
        value: value.replace(',', '.'),
      },
    });
  };

  if (!showInfoPayment) return <Fragment />;

  return (
    <>
      <div className="mt-3 flex items-center justify-between gap-4">
        <input
          type="text"
          pattern="[1-9][0-9]*"
          placeholder="Введите сумму"
          value={value}
          inputMode="numeric"
          onChange={handleChange}
          disabled={disabled}
          className={clsx(
            `w-full rounded-[8px] border border-black/50 border-grey-100 bg-transparent px-5 py-4 text-sm outline-none placeholder:text-grey-500 sm:p-3.5`,
            [hasError ? 'border-red' : 'border-black/50'],
            [disabled ? 'cursor-not-allowed' : 'cursor-text']
          )}
        />

        <Button
          type="button"
          isLoading={isPending}
          disabled={disabled}
          className="justify-center text-[14px]"
          onClick={handleCalculateCommission}
        >
          Посчитать
        </Button>
      </div>

      {salom === true ? (
        <InfoPayment
          group={false}
          className="mb-4"
          info={[
            { label: 'К оплате', value: `${infoPay?.totalAmount ?? 0} с.` },
          ]}
        />
      ) : (
        <InfoPayment
          className="my-4"
          info={[
            {
              label: 'Комиссия',
              value: `${numberFormat(Number(infoPay?.totalFee ?? 0))} c. ( ${infoPay?.feeInfo?.percent ?? 0}%
              ${infoStatic}${max || min ? ',' : ''}
              ${min} ${max})`,
            },
            {
              label: 'Сумма к зачислению',
              value: `${numberFormat(Number(value))} с.`,
            },
            {
              label: 'К оплате',
              value: `${numberFormat(Number(infoPay?.totalAmount ?? 0))} с.`,
            },
          ]}
        />
      )}
    </>
  );
};
